
import { threeFonts, loadFontGlyphs } from '../../../3dapps/js/fontUtils'
import * as THREE from 'three'
require('three-orbitcontrols');

export let scene;
export let camera;
export let renderer;

let scale;

export function initThree(canvas) {
    let canvas_bound = canvas.getBoundingClientRect();
    let controls;
    scene = new THREE.Scene(); //相机

    //创建3D世界
    let w = canvas_bound.width;
    let h = canvas_bound.height;

    //创建渲染器
    renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        antialias: true, //抗锯齿
        preserveDrawingBuffer: true, //3D加上这个在缩略图中可以变成白色
    });
    renderer.setSize(w, h);
    renderer.setClearColor(new THREE.Color("#778A99")); //把渲染器的背景变成白色
    renderer.setPixelRatio(2);


    // 创建场景
    // 量纲，单位 1px 1m 1kg
    camera = new THREE.PerspectiveCamera(70, w / h, 0.1, 2200);
    //定义相机的x,y,z位置
    camera.position.x = -200;
    camera.position.y = 250;
    camera.position.z = 280;
    camera.lookAt(scene.position); //把相机的位置渲染到场景中

    //控制器，鼠标左键和右键，滑轮操作
    controls = new THREE.OrbitControls(camera, canvas);
    //是否可以缩放
    controls.enableZoom = true;
    //设置相机距离原点的最远距离
    controls.minDistance = 20;
    controls.maxDistance = 700;

    // let axesHelper = new THREE.AxesHelper(100);
    // scene.add(axesHelper);

    // 灯光
    function addLights() {
        // 平行光
        let dirLight = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight.position.set(-30, 30, -30); //注意：位置一定要调整好，否则会出现物体变成黑色的情况
        scene.add(dirLight);

        let dirLight2 = new THREE.DirectionalLight(0xffffff, 0.5);
        dirLight2.position.set(30, 30, 50);
        scene.add(dirLight2);

        // 点光源
        let light = new THREE.PointLight(0xffffff, 0.6, 100);
        light.position.set(0, 0, 0);
        scene.add(light);

        // 环境光
        let ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
        scene.add(ambientLight);
    }
    addLights();
    
    // 天空盒
    var vertexShader = `
        varying vec3 vWorldPosition;
		void main() {
		    vec4 worldPosition = modelMatrix * vec4( position, 1.0 );
		    vWorldPosition = worldPosition.xyz;
		    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
		}
    `;
    var fragmentShader = `
        uniform vec3 topColor;
		uniform vec3 bottomColor;
		uniform float offset;
		uniform float exponent;
		varying vec3 vWorldPosition;
		void main() {
			float h = normalize( vWorldPosition + offset ).y;
			gl_FragColor = vec4(0.85 * mix( 0.85 * bottomColor, topColor, max( pow( max( h , 0.0), exponent ), 0.0 ) ), 1.0 );
		}
    `;
    var uniforms = {
        "topColor": { value: new THREE.Color(0xD0D5D7) },
        "bottomColor": { value: new THREE.Color(0x00AEF3) },
        // "topColor": { value: new THREE.Color(0xFFFFFF) },
        // "bottomColor": { value: new THREE.Color(0x87CEEB) },
        "offset": { value: 33 },
        "exponent": { value: 1.0 }
    };
    // uniforms[ "topColor" ].value.copy( hemiLight.color );

    var skyGeo = new THREE.SphereBufferGeometry(1000, 32, 15);
    var skyMat = new THREE.ShaderMaterial({
        uniforms: uniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        side: THREE.BackSide,
        // transparent: true,
        // opacity: 0.9
    });

    var sky = new THREE.Mesh(skyGeo, skyMat);
    sky.position.y = -100;
    scene.add(sky);

    //渲染场景
    function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
    }
    animate();
}

export let currentModel;

const material = new THREE.MeshPhongMaterial({
    reflectivity: 1,
});

let textSize; // 原始的尺寸

export async function updateModel(vue, fontName, text, lineHeight, rotateAngle) {
    if (currentModel) {
        scene.remove(currentModel);
        currentModel.geometry.dispose();
        currentModel = null;
    }

    let data = await initTextData(vue, fontName, text);
    let geom = addRotatePoly2(data, rotateAngle);
    let mesh = new THREE.Mesh(geom, material);

    let center = data.box.getCenter();
    textSize = data.box.getSize();

    scale = lineHeight / textSize.y;

    mesh.position.x = -center.x * scale;
    mesh.position.z = center.y * scale;
    mesh.rotation.x = -0.5 * Math.PI;
    mesh.scale.set(scale, scale, scale);
    scene.add(mesh);

    currentModel = mesh;
    return currentModel;
}

// 文本，计算必要的多边形数据，为旋转做准备。 
async function initTextData(vue, fontName, text) {
    // 获取threejs字体
    let font = threeFonts[fontName];

    await loadFontGlyphs(vue, fontName, text);

    // 如果字体不存在，则启用备用字体
    // 将字符串转换成几何形状
    let shapes = font.generateShapes(text, 12);

    let baseVertexes = [];
    let baseVertexesR = [];

    let contourList = [];
    let holeList = [];

    for (let i = 0; i < shapes.length; i++) {
        // 形状转多边形
        let shapePoints = shapes[i].extractPoints(12);
        // 外围包裹
        let contour = shapePoints.shape;
        // 内部孔洞
        let holes = shapePoints.holes;

        // 计算上下表面：这是二维的
        let faces = THREE.ShapeUtils.triangulateShape(contour, holes);
        let vertices = contour.slice();
        for (let h = 0, hl = holes.length; h < hl; h++) {
            vertices = vertices.concat(holes[h]);
        }

        for (let f = 0, fl = faces.length; f < fl; f++) {
            let face = faces[f];
            baseVertexes.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0
            );
            baseVertexesR.push(
                vertices[face[0]].x, vertices[face[0]].y, 0,
                vertices[face[2]].x, vertices[face[2]].y, 0,
                vertices[face[1]].x, vertices[face[1]].y, 0
            );
        }

        contourList.push(contour);
        holeList.push(...holes);
    }

    let box = new THREE.Box2();
    for (let c of contourList) {
        for (let p of c) {
            box.expandByPoint(p);
        }
    }

    return {
        box,
        baseVertexes,
        baseVertexesR,
        contourList,
        holeList
    }
}


function makeGeomFromVertexes(vertexes) {
    let geom = new THREE.BufferGeometry();
    geom.setAttribute("position", new THREE.BufferAttribute(new Float32Array(vertexes), 3));
    geom.computeVertexNormals();
    return geom;
}

// 绕轴旋转多边形
function addRotatePoly2(data, rotateAngle) {
    let vertexes = [];
    let shiftY = - data.box.min.y + 2;
    let N = Math.ceil(rotateAngle / 0.03);
    for (let c of data.contourList) {
        c.reverse();
        let c1 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0));
        for (let i = 1, s = rotateAngle / N; i <= N; i++) {
            let angle = i * s;
            let m = new THREE.Matrix4();
            m.makeRotationX(angle);

            let c2 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0).applyMatrix4(m));
            addBound(vertexes, c1, c2);
            c1 = c2;
        }
    }

    for (let c of data.holeList) {
        c.reverse();
        let c1 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0));
        for (let i = 1, s = rotateAngle / N; i <= N; i++) {
            let angle = i * s;
            let m = new THREE.Matrix4();
            m.makeRotationX(angle);

            let c2 = c.map(p => new THREE.Vector3(p.x, p.y + shiftY, 0).applyMatrix4(m));
            addBound(vertexes, c1, c2);
            c1 = c2;
        }
    }

    let m1 = new THREE.Matrix4();
    m1.makeRotationX(rotateAngle);
    for (let i = 0; i < data.baseVertexes.length; i += 3) {
        let p = new THREE.Vector3(data.baseVertexes[i], data.baseVertexes[i + 1] + shiftY, data.baseVertexes[i + 2]);
        p.applyMatrix4(m1);
        vertexes.push(p.x, p.y, p.z);
    }
    for (let i = 0; i < data.baseVertexesR.length; i += 3) {
        vertexes.push(data.baseVertexes[i], data.baseVertexes[i + 1] + shiftY, data.baseVertexes[i + 2]);
    }

    // vertexes = [];
    const padding = 2;
    const thickness = 2;
    // 多加个一个底座。底座比字体多一个padding大小。
    addBox(vertexes, data.box.min.x - padding, data.box.max.x + padding, data.box.min.y + shiftY - padding, data.box.max.y + shiftY + padding, - thickness, 0);

    return makeGeomFromVertexes(vertexes);
}

function addBox(vertexes, x1, x2, y1, y2, z1, z2) {
    let a1 = new THREE.Vector3(x1, y1, z1);
    let b1 = new THREE.Vector3(x2, y1, z1);
    let c1 = new THREE.Vector3(x2, y2, z1);
    let d1 = new THREE.Vector3(x1, y2, z1);

    let a2 = new THREE.Vector3(x1, y1, z2);
    let b2 = new THREE.Vector3(x2, y1, z2);
    let c2 = new THREE.Vector3(x2, y2, z2);
    let d2 = new THREE.Vector3(x1, y2, z2);

    addRect(vertexes, d1, c1, b1, a1);
    addRect(vertexes, a2, b2, c2, d2);
    addBound(vertexes, [a1, b1, c1, d1], [a2, b2, c2, d2]);
}


// 两个多边形之间的壁
function addBound(vertexes, poly1, poly2) {
    let v2_1 = poly1[poly1.length - 1];
    let v2_2 = poly2[poly2.length - 1];
    for (let i = 0; i < poly1.length; i++) {
        let v1_1 = poly1[i];
        let v1_2 = poly2[i];
        addRect(vertexes, v2_1, v1_1, v1_2, v2_2);

        v2_1 = v1_1;
        v2_2 = v1_2;
    }
}

// 将一个矩形转换为两个三角形
function addRect(vertexes, a, b, c, d) {
    addTriangle(vertexes, a, b, c);
    addTriangle(vertexes, a, c, d);
}

// 将一个三角形加入顶点数组
function addTriangle(vertexes, a, b, c) {
    vertexes.push(a.x, a.y, a.z, b.x, b.y, b.z, c.x, c.y, c.z);
}






// WEBPACK FOOTER //
// ./src/views/lampshade3d/scripts/makeModel.js